import type { Product, ProductScreenshot } from '../data/products';

function sameSrc(a?: string | null, b?: string | null) {
  if (!a || !b) return false;
  return a.trim() === b.trim();
}

/** Marketplace card / detail hero — never let gallery screenshots steal this slot. */
export function productHeroShot(product: Product): ProductScreenshot | null {
  const hero = product.heroImageUrl?.trim();
  if (hero) {
    return { src: hero, alt: `${product.name} hero` };
  }
  return product.screenshots[0] ?? null;
}

/**
 * Product gallery only. If Espo set a dedicated heroImageUrl, keep it out of the
 * rotating screenshot list so the hero is not overwritten by the other shots.
 */
export function productGalleryShots(product: Product): ProductScreenshot[] {
  const hero = product.heroImageUrl?.trim() || null;
  const unique: ProductScreenshot[] = [];
  const seen = new Set<string>();

  for (const shot of product.screenshots) {
    const src = shot.src?.trim();
    if (!src || seen.has(src) || sameSrc(src, hero)) continue;
    seen.add(src);
    unique.push({ ...shot, src });
  }

  if (unique.length) return unique;
  return product.screenshots;
}
